export default class Strategy {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || '';
    this.company = data.company || '';
    this.store_id = data.store_id || '';
    this.product_selection_type = data.product_selection_type || '';
    this.product_ids = data.product_ids || [];
    this.filters = data.filters || null;
    this.pricing_parameters = data.pricing_parameters || this.getDefaultPricingParameters();
    this.schedule = data.schedule || null;
    const defaultSettings = {
      order_type: 'fbs',
      check_rrp: false,
      rrp_price_type: 'standard',
      skip_price_decrease: false,
    };
    this.settings = { ...defaultSettings, ...(data.settings || {}) };
    if (!this.settings.rrp_price_type) {
      this.settings.rrp_price_type = 'standard';
    }
    this.last_run = data.last_run || null;
    this.last_run_result = data.last_run_result || null;
    this.is_active = data.is_active || false;
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
    this.errors = [];
    this._originalState = JSON.parse(JSON.stringify(this.toJSON()));
  }

  // Метод для создания пустой стратегии (новой)
  static createNew() {
    return new Strategy({
      is_active: true,
      name: 'Без названия',
      value_type: 'price',
      value_set_type: 'for_all',
      product_selection_type: 'by_id',
      product_ids: []
    });
  }

  // Получение дефолтных параметров ценообразования
  getDefaultPricingParameters() {
    return {
      type: 'profit_percent',
      value_set_type: 'for_all',
      value_for_all: 0,
      value_individual: null
    };
  }
  verify() {
    this.errors = [];
    if (!this.name) {
      this.errors.push('Введите название стратегии');
    }
    if (!this.store_id) {
      this.errors.push('Выберите магазин');
    }
    if (this.product_selection_type === 'by_filter') {
      if (!this.filters) {
        this.errors.push('Настройте фильтры товаров');
      } else {
        if (!this.filters.company) {
          this.errors.push('Выберите компанию в фильтрах');
        }
        // Проверяем наличие хотя бы одного заполненного фильтра
        const hasAnyFilter = Object.entries(this.filters).some(([key, value]) => {
          if (key === 'company' || key === 'page' || key === 'size') return false; // Пропускаем служебные поля
          if (!value) return false; // Пропускаем null и undefined
          if (Array.isArray(value)) return value.length > 0;
          if (typeof value === 'object') {
            try {
              return Object.keys(value).length > 0;
            } catch (e) {
              return false;
            }
          }
          return !!value;
        });
        if (!hasAnyFilter) {
          this.errors.push('Добавьте хотя бы один фильтр товаров');
        }
      }
    }
    if (this.product_selection_type === 'by_id') {
      if (!this.product_ids || this.product_ids.length === 0) {
        this.errors.push('Выберите товары');
      }
    }
    if (this.pricing_parameters.value_set_type === 'for_all') {
      if (this.pricing_parameters.value_for_all === undefined ||
        this.pricing_parameters.value_for_all === null) {
        this.errors.push('Укажите значение для всех товаров');
      }
    }
    if (this.pricing_parameters.value_set_type === 'individual') {
      if (!this.pricing_parameters.value_individual || typeof this.pricing_parameters.value_individual !== 'object') {
        this.errors.push('Укажите значения для выбранных товаров');
      } else {
        // Проверяем, что для каждого ID из product_ids есть значение в value_individual
        for (const productId of this.product_ids) {
          if (
            this.pricing_parameters.value_individual[productId] === undefined ||
            this.pricing_parameters.value_individual[productId] === null ||
            (typeof this.pricing_parameters.value_individual[productId] === 'string' && this.pricing_parameters.value_individual[productId].trim() === '') ||
            isNaN(parseFloat(this.pricing_parameters.value_individual[productId])) ||
            parseFloat(this.pricing_parameters.value_individual[productId]) === 0
          ) {
            this.errors.push('Укажите значения для всех выбранных товаров');
            break;
          }
        }
      }
    }
    return this.errors.length === 0;
  }

  getErrors() {
    return this.errors;
  }

  // Метод для преобразования в JSON для отправки на сервер
  toJSON() {
    return {
      name: this.name,
      company: this.company,
      store_id: this.store_id,
      product_selection_type: this.product_selection_type,
      product_ids: this.product_ids,
      filters: this.filters,
      pricing_parameters: this.pricing_parameters,
      schedule: this.schedule,
      settings: this.settings,
      is_active: this.is_active
    };
  }

  isChanged() {
    const currentState = JSON.parse(JSON.stringify(this.toJSON()));
    return JSON.stringify(currentState) !== JSON.stringify(this._originalState);
  }

  resetChangeTracking() {
    this._originalState = JSON.parse(JSON.stringify(this.toJSON()));
  }
}